// Farm/Block/Kc types mirror functions/_lib/farms.ts and functions/_lib/kc.ts.
// Duplicated rather than shared because the admin is a separate bundle path
// and we don't have a shared types package (same rationale as the campaign
// types duplicated in AdminApp.tsx).

export const CROP_IDS = ['olive', 'eucalyptus', 'waxflower', 'myrtle', 'boxwood'] as const;
export type CropId = (typeof CROP_IDS)[number];

export const CROP_LABELS: Record<CropId, string> = {
  olive: 'Olive',
  eucalyptus: 'Eucalyptus',
  waxflower: 'Waxflower',
  myrtle: 'Myrtle',
  boxwood: 'Boxwood',
};

export interface FarmStation {
  kind: 'ambient-pws' | 'lora' | 'none';
  deviceId: string | null;
}

export interface SensorRef {
  id: string;
  kind: 'soil-moisture';
  depthIn: number | null;
  label: string;
}

export interface Block {
  id: string;
  name: string;
  crop: CropId;
  variety: string | null;
  acreage: number;
  plantCount: number;
  rowSpacingFt: number;
  inRowSpacingFt: number;
  emittersPerPlant: number;
  gphPerEmitter: number;
  canopyCoverPct: number;
  matureCoverPct: number;
  efficiencyPct: number;
  kcOverride: number | null;
  notes: string;
  configured: boolean;
  sensors: SensorRef[];
}

export interface Farm {
  id: string;
  name: string;
  lat: number;
  lon: number;
  cimisStationId: string;
  station: FarmStation;
  rainThresholdIn: number;
  rainEffectivenessPct: number;
  blocks: Block[];
}

export interface KcRow {
  crop: CropId;
  variety: string | null;
  kc: number;
  source: string;
  estimate: boolean;
}

// D-11/spacing helpers: keep acreage and plantCount in sync as the grower
// edits either field or the row/in-row spacing.
export function plantCountFromAcreage(acreage: number, rowFt: number, inRowFt: number): number {
  return Math.max(1, Math.round((acreage * 43560) / (rowFt * inRowFt)));
}

export function acreageFromPlantCount(count: number, rowFt: number, inRowFt: number): number {
  return Math.round(((count * rowFt * inRowFt) / 43560) * 100) / 100;
}
